import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesTasksOrderPostAsyncSlice } from './post';

export const coreInitiativesTasksOrderReducers = combineReducers({
	post: coreInitiativesTasksOrderPostAsyncSlice.asyncReducers
});

export const coreInitiativesTasksOrderWatchers = combineAllWatchers([
	coreInitiativesTasksOrderPostAsyncSlice.asyncWatchers
]);
